import { render, staticRenderFns } from "./PropertySearch.vue?vue&type=template&id=1a90e955&"
import script from "./PropertySearch.vue?vue&type=script&lang=js&"
export * from "./PropertySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports